import React, { useEffect, useState } from 'react'
import { TabView, TabPanel } from 'primereact/tabview';
import CreateExpense from './create-expenses';
import MyExpenses from './my-expenses';
import TeamExpenses from './team-expenses';
import FinanceExpenses from './finance-expenses';
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import { expenseApi } from '../../services';
import ExpenseCategoryManager from './expense-category-manager';
import ProtectedSection from "../../components/protected/ProtectedSection";
import { hasPermission } from "../../components/protected/ProtectedSection";
import { EXPENSES_APPROVAL, EXPENSES_FINANCE_APPROVAL, EXPENSES_CATEGORY, APPLICATION_VIEW_, EXPENSES_MENU_VIEW } from "../../config/permissions";
import ExpenseDashboard from './expense-dashboard';
function Expenses() {
    const [activeIndex, setActiveIndex] = useState(0);
    const user = useSelector(selectUser);
    const [isEmployee, setIsEmployee] = useState(false);
    const [expenseCategories, setExpenseCategories] = useState(null);
    const [items, setItems] = useState([]);

    useEffect(() => {
        const fItems = ([
            { label: "Create Expenses", icon: "pi pi-book", permission: EXPENSES_MENU_VIEW },
            { label: "My Expenses", icon: "pi pi-wallet", permission: EXPENSES_MENU_VIEW },
            { label: "Team Expenses", icon: "pi pi-wallet", permission: EXPENSES_APPROVAL },
            { label: "Expenses Approval", icon: "pi pi-thumbs-up", permission: EXPENSES_APPROVAL },
            { label: "Expenses Category Approval", icon: "pi pi-car", permission: EXPENSES_CATEGORY },
            { label: "Finance Approval", icon: "pi pi-money-bill", permission: EXPENSES_FINANCE_APPROVAL },
        ]);
        setItems(fItems);
    }, [])

    const ActiveTab = () => {
        switch (activeIndex) {
            case 0:
                return <ProtectedSection permissions={[EXPENSES_MENU_VIEW]}><CreateExpense status={0} userLegalEntity={user?.LegalEntity?.code} /></ProtectedSection>;
            case 1:
                return <ProtectedSection permissions={[EXPENSES_MENU_VIEW]}><MyExpenses status={1} expenseCategory={expenseCategories} /></ProtectedSection>;
            case 2:
                return <ProtectedSection permissions={[EXPENSES_APPROVAL]}><ExpenseDashboard /></ProtectedSection>;
            case 3:
                return <ProtectedSection permissions={[EXPENSES_APPROVAL]}><TeamExpenses /></ProtectedSection>;
            case 4:
                return <ProtectedSection permissions={[EXPENSES_CATEGORY]}><ExpenseCategoryManager /></ProtectedSection>;
            case 5:
                return <ProtectedSection permissions={[EXPENSES_FINANCE_APPROVAL]}><FinanceExpenses /></ProtectedSection>;
            default:
                return <ProtectedSection permissions={[EXPENSES_MENU_VIEW]}> <CreateExpense status={0} /></ProtectedSection>;
        }
    };
    useEffect(() => {
        const empIndex = user.roles.indexOf('manager');
        setIsEmployee(empIndex !== -1);
    });
    useEffect(() => {
        getExpenseCategories();
    }, []);

    const getExpenseCategories = () => {
        expenseApi.getCategories().then((resp) => {
            setExpenseCategories(resp.data.data)
        })
    }
    const getTabBody = (tab) => {
        return (
            <div>
                <span className={tab.icon} style={{ marginRight: "3%" }}></span>
                {tab.label}
            </div>
        );
    };
    return (<div>
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            {items.map((tab) => {
                return (
                    hasPermission(tab.permission) ? 
                    <TabPanel key={tab.label} header={getTabBody(tab)} disabled={!hasPermission(tab.permission)}>
                        <p className="m-0">
                            <ActiveTab />
                        </p>
                    </TabPanel>
                    : ''
                );
            })}
        </TabView>
    </div>
    )
}

export default Expenses;